<template>
  <v-container class="wrapper">
    <div class="text-center">
      <div class="text-h4 gray">My Favorite Jobs</div>
      <div v-if="jobs && jobs.length === 0">
        <p class="text-center mt-2">
          You don't have any saved jobs at the moment
        </p>
      </div>
    </div>
    <v-row class="mt-5 course-results">
      <v-col
        xl="3"
        lg="3"
        md="3"
        sm="6"
        xs="6"
        class="d-flex"
        v-for="job in jobs"
        :key="job.job_id"
      >
        <job-card
          :job="job"
          outlined
          :to="'/app/' + userType + '/job/' + job.job_id"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import JobCard from "@/components/JobCard.vue";
export default {
  name: "MyJobs",
  components: { JobCard },
  data() {
    return {
      jobs: null,
      // Snackbar
      snackbar_show: false,
      snackbar_color: null,
      snackbar_text: null,
      snackbar_icon: null,
      // Used to build the job urls
      userType: null,
      // env
      VUE_APP_API_ENDPOINT: process.env.VUE_APP_API_ENDPOINT,
    };
  },

  async mounted() {
    try {
      await this.getData();
    } catch (error) {
      if (error.message.includes("Authentication failed")) {
        this.$router.push("/auth-error");
      }
    }
    this.userType = this.$route.path.match(/\/app\/(.+?)\//)[1];
  },

  methods: {
    async getData() {
      let response = await fetch(
        // We reuse the search-courses endpoint since it returns the fav jobs
        process.env.VUE_APP_API_ENDPOINT + "common/search-jobs",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Auth-Token": this.$cookie.get("jwt_token"),
          },
        }
      );
      response = await response.json();
      if (response.success) {
        this.jobs = response.result.jobs;
      } else {
        throw new Error(response.message);
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 40px;
}

.no-link {
  text-decoration: none;
  color: black;
}
.card-title {
  text-transform: capitalize;
  word-break: normal;
}
.gray {
  color: #283444;
}
</style>
